export const GAP = 6;
export const ENTER_DISTANCE = 4;
export const ENTER_DURATION_MS = 90;
export const SHOW_DELAY_MS = 300;
export const VIEWPORT_PADDING = 8;
// Between the modal container (2000) and the toasts (2002).
export const Z_INDEX = 2001;
